import type { ModalFuncProps } from 'antd';
import { Icon } from '../../icons';

type ConfirmModalIconProperties = {
  type: ModalFuncProps['type'];
};

export const ConfirmModalIcon = ({ type }: ConfirmModalIconProperties) => {
  switch (type) {
    // TODO: `confirm` type doesn't exist in our design system
    case 'confirm':
    case 'info':
      return <Icon color="info" icon="information-line" />;
    case 'error':
      return <Icon color="error" icon="close-circle-line" />;
    case 'success':
      return <Icon color="success" icon="check-circle-line" />;
    case undefined:
      return undefined;
    case 'warn':
    case 'warning':
      return <Icon color="warning" icon="warning-line" />;
  }
};
